import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { svg_mobile_transparent_600_by_300 } from '../../../helpers/svg_file';

const PreLogin = (props) => {
  // Init assest
  const initAssetConfig = {
    width: '257px',
    height: '180px',
    alt: 'defautl alt',
    description: 'default description',
    image: svg_mobile_transparent_600_by_300,
    link: '',
    image_status: '',
  }
  // Set & get state
  const [asset, setAsset] = useState(initAssetConfig);
  const [shortAsset, setShortAsset] = useState(initAssetConfig);
  const [isPopupEnabled, setIsPopupEnabled] = useState(true);

  // Fetch other media
  const { otherMedia } = useSelector(state => ({
    otherMedia: state.othermediaInformationListR.data
  }));

  // Effect call for manupulate data
  useEffect(() => {
    // setAsset(initAssetConfig);
    // Width
    let tempAsset = {};
    if (typeof otherMedia['pop_up_before_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_before_login']?.[0]['width'] != 'undefined') {
      tempAsset['width'] = otherMedia['pop_up_before_login']?.[0]['width'];
    }

    // Heigth
    if (typeof otherMedia['pop_up_before_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_before_login']?.[0]['height'] != 'undefined') {
      tempAsset['height'] = otherMedia['pop_up_before_login']?.[0]['height'];
    }

    // Description
    if (typeof otherMedia['pop_up_before_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_before_login']?.[0]['description'] != 'undefined') {
      tempAsset['description'] = otherMedia['pop_up_before_login']?.[0]['description'];
    }

    // alternative
    if (typeof otherMedia['pop_up_before_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_before_login']?.[0]['alternate'] != 'undefined') {
      tempAsset['alt'] = otherMedia['pop_up_before_login']?.[0]['alternate'];
    }

    if (typeof otherMedia['pop_up_before_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_before_login']?.[0]['link'] != 'undefined') {
      tempAsset['link'] = otherMedia['pop_up_before_login']?.[0]['link'];
    }

    if (typeof otherMedia['pop_up_before_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_before_login']?.[0]['image_status'] != 'undefined') {
      tempAsset['image_status'] = otherMedia['pop_up_before_login']?.[0]['image_status'];
    }
    // Image path
    if (typeof otherMedia['pop_up_before_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_before_login']?.[0]['path'] != 'undefined') {
      tempAsset['image'] = otherMedia['pop_up_before_login']?.[0]['path'];
    }
    setShortAsset((previousAssets) => ({ ...previousAssets, ...tempAsset }));
    if (tempAsset['link'] !== '' && tempAsset['image_status'] !== '') {
      let tempInitAssetConfig = initAssetConfig;
      tempInitAssetConfig['link'] = tempAsset['link'];
      tempInitAssetConfig['image_status'] = tempAsset['image_status'];
      setAsset((previousAssets) => ({ ...previousAssets, ...tempInitAssetConfig }));
    }
  }, [otherMedia]);

  useEffect(() => {
    if (shortAsset['link'] !== '' && shortAsset['image_status'] !== '') {
      const img = new Image();
      img.onload = () => {
        const callMe = (shortAsset) => {
          setAsset(shortAsset);
        };
        setTimeout(callMe, 1000, shortAsset);
      };
      img.src = shortAsset['image'];
    }
  }, [shortAsset]);

  return (
    <>
      {
        asset['image_status'] !== '' && asset['link'] !== '' && <>
          <Link to={asset['link']} onClick={() => props.handle()}>
            <div className='popup-box1'>
              <div>
                {/* <link rel="preload" href={asset['image']} as="image" /> */}
                <img src={asset['image']} width="400" height="auto" alt={asset['alt']}
                />
              </div>
            </div>
          </Link>
          <div className='check'>
            <div className="d-flex prelogin-check align-items-center">
              <input
                type="checkbox"
                id="checkbor_arr"
                name="checkbor_arr"
                checked={!isPopupEnabled}
                onChange={() => { }}
                onClick={() => {
                  props?.handlePopupCheckbox(isPopupEnabled); setIsPopupEnabled(!isPopupEnabled)
                }}
              />
              <span></span>

              <label className="form-check-label" htmlFor="flexCheckChecked">
                {props.t('dont_show_again')}
              </label>
            </div>
          </div>
        </>
      }
    </>
  )
}

PreLogin.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(PreLogin);